enum ActionTypes {
    SAVE_USER = "SAVE_USER",
    LOADING_USER = "LOADING_USER",
    LOGOUT_ACTION = "LOGOUT_ACTION",
}

export default ActionTypes;
